import type React from 'react'

import { timestampDate } from '@bufbuild/protobuf/wkt'
import type { Supply48LastUpdated } from '@ebalance/proto/bffuser/v1/supply_48_data_model_pb'
import { useTranslation } from 'react-i18next'

import { Text } from '@enechain/ecloud-designsystem'

import { useMemberDisplayName } from '~/hooks/member/useMemberDisplayName'
import { formatJstDateTimeHm } from '~/models/dateTime'

const EMPTY = '—'

type Props = {
  /** 表示対象の最終更新 (応答に無ければ undefined = 行が 1 つも無い)。 */
  lastUpdated: Supply48LastUpdated | undefined
}

/**
 * AC-S4D-025: 表示中の 48 点データの最終更新日時 (JST) と更新者。
 * 行が無ければ「最終更新: —」、 更新者を解決できない時 ("system" を含む) は名前を「—」にし、
 * 生の member id は出さない。
 */
export const LastUpdatedCaption = ({
  lastUpdated,
}: Props): React.JSX.Element => {
  const { t } = useTranslation()
  const resolveMemberName = useMemberDisplayName()

  const text =
    lastUpdated?.updatedAt === undefined
      ? t('page:supply48Data.meta.lastUpdatedEmpty')
      : t('page:supply48Data.meta.lastUpdated', {
          at: formatJstDateTimeHm(timestampDate(lastUpdated.updatedAt)),
          by: resolveMemberName(lastUpdated.updatedBy) ?? EMPTY,
        })

  return (
    <Text textStyle="caption" color="Text.midEmphasis">
      {text}
    </Text>
  )
}
